<template>
    <div>
      <div class="text-h5">
          <v-icon large>mdi-calendar</v-icon> {{ $t('reservation_date_title') }}
      </div>
        <div align="center" class="mt-8">
            <Calendar
                @dayclick="selectdate"
                :attributes='calendar_attrs'
                :locale="{id:$i18n.locale }"
                :available-dates="available_dates"
            >
            </Calendar>
        </div>
    </div>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'
import Calendar from 'v-calendar/lib/components/calendar.umd'

export default {
  props: ['nextstep'],
  components: {Calendar},
  data () {
    return {
        calendar_attrs : []
        ,available_dates : []
    }
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.appointment.get_calendar,{group_id:AppointmentSelection.getGroupId()})
    .then(response => {
        this.available_dates =  response.data.calendar.filter((i)=>!i.is_close).map((i)=>i.datee)
        this.$store.commit('finishLoading',que)
    })
  },
  methods : {
    selectdate(date){
        if(this.available_dates.includes(date.id)){
          AppointmentSelection.setDate(date.id)
          this.nextstep()
        }
    }
  },
}
</script>